class SeatplanDetailsCtrl {
    constructor($state, model, Workflows, NavService) {
        this.state = $state;
        this.model = model;
        this.workflows = Workflows;
        this.navService = NavService;
        this.currentView = 'general';
        this.updateCustomActions();
    }

    cancel() {
        this.state.go('app.seatplans.index');
    }

    editElements(group) {
        this.state.go('app.seatplans.elements', {id: group.id});
    }

    updateCustomActions() {
        const actions = this.workflows.getWorkflows('seatplan')
            .filter(workflow => {
                return this.model.archived ? workflow.level === 'archived-highlight' : workflow.level === 'highlight';
            })
            .map(workflow => {
                if (!workflow.onClick) {
                    workflow.onClick = workflow.action;
                }

                workflow.action = () => {
                    workflow.onClick(this.model, this);
                };

                return workflow;
            });

        this.navService.overrideMainSideNavActions(actions);

        this.navService.setStateParameters('app.seatplans.details', {
            id: this.model.id
        });
        this.navService.setBreadcrumbParameters({
            seatplan_name: this.model.title
        });
        let customs = [
            {
                label: 'General',
                active: (this.currentView === 'general'),
                icon: 'info',
                order: 5,
                action: () => {
                    this.changeView('general');
                }
            },
            {
                label: 'Groups',
                active: (this.currentView === 'groups'),
                icon: 'sitemap',
                order: 10,
                action: () => {
                    this.changeView('groups');
                }
            }
        ];


        this.navService.setSideNavCustoms(_.sortBy(customs, 'order'));
    }

    changeView(newView) {
        this.currentView = newView;
        this.updateCustomActions();
    }
}

SeatplanDetailsCtrl.$inject = [
    '$state',
    'model',
    'Workflows',
    'NavService'
];

/**
 * @ngdoc object
 * @name templates.controller:TemplatesCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.seatplans')
    .controller('SeatplansDetailsCtrl', SeatplanDetailsCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/controllers/seatplans-details-controller.js